module.exports = __webpack_public_path__ + "img/user.fccb47cb.png";